module.exports = __webpack_public_path__ + "static/media/view.3e376c0f.svg";